import {
    Sprite,
} from 'pixi.js';
import { CommonButton } from './CommonButton';

export class SpriteButton extends CommonButton {
    constructor(texture, options = {ignorePivot : false, isNegative : false}){
        const sprite = new Sprite(texture);
        super(sprite, options);
        this.sprite = sprite;
    }
}
